import './ConfirmationDialog.scss'

import React, { useCallback } from 'react'

import Button from '../../components/Button/Button'
import Modal from '../../components/Modal/Modal'
import { closeEvent } from '../../components/Modal/ModalEvents'
import t from '../../helpers/i18n'

const ConfirmationModal = ({ title, description, actionLabel, danger, onAccepted, onCancelled }) => {

  const handleClose = useCallback(success => {
    if (success && onAccepted) onAccepted()
    if (!success && onCancelled) onCancelled()
  }, [onAccepted, onCancelled])

  return (
    <Modal dialog onCloseRequested={handleClose}>
      <div className="confirmation-dialog">
        <div className="-title label-large-medium">{title}</div>
        <div className="-description caption-default-basic">{description}</div>
        <div className="-buttons">
          <Button
            label={t('buttons.Cancel')}
            size="field-sized"
            type="light"
            onClick={(event) => closeEvent(event.currentTarget, false)}
          />
          <Button
            label={actionLabel}
            size="field-sized"
            type="dark"
            color={danger ? "red" : "green"}
            onClick={(event) => closeEvent(event.currentTarget, true)}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationModal